
































































































































































































































import ArriveAvailabilityCalendar from '@/components/global/ArriveAvailabilityCalendar.vue'
import ArriveLocationsList from '@/components/global/ArriveLocationsList.vue'
import LoadingAnimation from '@axCommerce/components/loading-animation.vue'
import LocalVue from '@/classes/local-vue.class'
import MobileAddToCartBar from '@/components/mobile-add-to-cart-bar.vue'
import ProductParkingSelections from '@/components/product-parking-selections.vue'
import ProductSummary from '@/components/product-summary.vue'
import { Action, Getter } from 'vuex-class'
import { AnalyticsTracking } from '@axCommerce/mixins/analytics-tracking'
import { CartUtils } from '@axCommerce/mixins/cart-utils'
import { Component } from 'vue-property-decorator'
import { FormManagement } from '@axCommerce/mixins/form-management'
import { ProductInterface } from '@/interfaces/product.interface'
import { ProductUtils } from '@axCommerce/mixins/product-utils'
import { TextFormatting } from '@axCommerce/mixins/text-formatting'
import { Validate } from 'vuelidate-property-decorators'
import { format } from 'date-fns'
import { emitEvent, unregisterEvent, registerEvent, AxEventType } from '@aspenware-library/event-hub'
import { endsWith } from 'lodash'
import { categoryGetters, publicUIPathGetters } from '@aspenware-library/composables'

const arriveParkSettingsVar = (window as any).arriveParkSettings

@Component({
  name: 'productTemplate-parking',
  mixins: [ProductUtils, FormManagement, AnalyticsTracking, CartUtils, TextFormatting],
  components: {
    ArriveAvailabilityCalendar,
    ArriveLocationsList,
    LoadingAnimation,
    MobileAddToCartBar,
    ProductParkingSelections,
    ProductSummary,
  },
})
export default class ProductTemplateParkingComponent extends LocalVue {
  @Getter('cart/showCartCard') showCartCard
  @Getter('products/selectedProduct') product
  @Getter('products/productAttributes') productAttributes
  @Getter('cart/cartAdding') addingToCart

  private dialog: boolean = false
  private initialAvailabilityDate: string = ''
  private selectedDate: string = ''
  private selectedDateAvailability: any = null
  private selectedDateAvailableLots: any[] = []
  private showCalendar: boolean = false

  created() {
    registerEvent('ASPENWARE_ARRIVE_DAYSELECTED', this.onDaySelected)
    registerEvent('ASPENWARE_ARRIVE_LOCATIONSELECTED', this.onLocationSelected)
  }

  destroyed() {
    unregisterEvent('ASPENWARE_ARRIVE_DAYSELECTED')
  }

  mounted() {
    this.$store.dispatch('products/loadProductDetails')

    const root = document.getElementsByTagName('html')[0] as HTMLElement
    root.classList.add('html-product-detail-page')
    root.classList.remove('html-category-page')
    if (this.startDateAttribute && this.startDateAttribute.DefaultValue) {
      this.initialAvailabilityDate = this.startDateAttribute.DefaultValue
    }
    if (!this.initialAvailabilityDate && this.dateAttribute && !this.dateAttribute.SelectedValue) {
      this.showCalendar = !this.$vuetify.breakpoint.smAndDown // Only automatically show the calendar on desktop
    }
  }

  get languageSettings(): any {
    // arriveParkingSettings declared in global.d.ts
    return window.arriveParkingSettings?.LanguageStrings || {}
  }

  @Validate({
    $each: {
      validRequired(value) {
        return !!value?.SelectedValue || !!value?.SelectedValueId
      },
    },
  })
  get requiredAttributes(): any[] {
    return this.productAttributes ? this.productAttributes.filter((attr) => attr.IsRequired && !attr.IsDisabled) : []
  }

  get lowestAvailablePrice() {
    let price = this.selectedDateAvailability ? `$${this.selectedDateAvailability.lowestPrice.toFixed(2)}` : ''
    if (price && endsWith(price, '.00')) {
      price = price.substring(0, price.length - 3)
    }
    return price
  }

  get formattedSelectedDate() {
    if (this.selectedDate) {
      const dateKey = `${this.selectedDate}T00:00:00`
      return format(new Date(dateKey), 'EEEE, MMM dd, yyyy')
    }

    return null
  }

  private onDateMenuOpened() {
    emitEvent('ASPENWARE_ARRIVE_DATEOPENED')
  }

  private triggerSelectLocation() {
    emitEvent('ASPENWARE_ARRIVE_SELECTLOCATION')
  }

  /**
   * @NOTE this is a bad idea, but there isn't a better way at the moment
   *       to retrieve the globally selected product Id
   */
  get selectedProduct(): any | undefined {
    const storeProduct = this.$store?.state?.products?.selectedProduct
    return storeProduct ? this.convertProductModel(storeProduct) : undefined
  }

  private onDaySelected(availabilityInfo) {
    this.showCalendar = false
    this.selectedDate = availabilityInfo.date
    this.selectedDateAvailability = availabilityInfo.availability
    this.selectedDateAvailableLots = availabilityInfo?.availability?.lots

    if (this.dateAttribute) {
      this.$set(this.dateAttribute, 'SelectedValue', this.selectedDate)
      this.$set(this.dateAttribute, 'SelectedValueId', this.selectedDate)
      if (this.startDateAttribute) {
        const selDate = new Date(`${this.selectedDate}T00:00:00`)
        const selMonth = selDate.getMonth() + 1
        const selYear = selDate.getFullYear()
        const selDay = selDate.getDate()
        this.$set(this.startDateAttribute, 'IsDate', true)
        this.$set(this.startDateAttribute, 'SelectedMonth', selMonth)
        this.$set(this.startDateAttribute, 'SelectedYear', selYear)
        this.$set(this.startDateAttribute, 'SelectedDay', selDay)
        this.$set(this.startDateAttribute, 'SelectedValue', this.selectedDate)
        this.$set(this.startDateAttribute, 'SelectedValueId', this.selectedDate)
      }
    }
  }

  private onLocationSelected(location) {
    let locationId = null
    let lotName = null
    let price = null
    let eventId = null
    let time = null

    if (location) {
      if (this.lotIdAttribute) {
        locationId = location.locationId
      }
      if (this.lotNameAttribute) {
        lotName = location.lotName
      }
      if (this.timeAttribute) {
        time = location.startTime || null
      }
      if (this.priceAttribute) {
        price = location.price.toFixed(2)
      }
      if (this.eventIdAttribute) {
        eventId = location.eventId
      }
    }

    this.$set(this.lotIdAttribute, 'SelectedValue', locationId)
    this.$set(this.lotNameAttribute, 'SelectedValue', lotName)
    if (this.timeAttribute) {
      this.$set(this.timeAttribute, 'SelectedValue', time)
    }
    this.$set(this.priceAttribute, 'SelectedValue', price)
    this.$set(this.eventIdAttribute, 'SelectedValue', eventId)
  }

  public async addToCart(): Promise<void> {
    try {
      const result = await this.$store.dispatch('cart/addToCart', {
        productId: this.product.Id,
        productAttributes: this.product.ProductAttributes,
      })

      this.getCartData(null, true, this.onCartReload)
    } catch (error) {
      this.cartError = error.response.data.message[0]
    } finally {
    }
  }

  backToCategory() {
    // Reset the slider position for products to the first image
    var currentCategory = this.$route.params.category
    var currentSubcategory = this.$route.params.subcategory
    const root = document.getElementsByTagName('html')[0] as HTMLElement
    root.classList.remove('html-product-detail-page')
    root.classList.add('html-category-page')
    this.toggleCartCard()

    if (this.category && this.category.ShowPricingCalendar) {
      if (window.storeSettings.CloudEnabled && !this.category.UseLegacy) {
        window.location.href = publicUIPathGetters.getFullPageCalendarPath(currentCategory, currentSubcategory, this.category.PricingCalendarProduct)
      } else {
        this.$router.push({
          name: 'product-pricing-calendar',
          params: {
            category: currentCategory,
            subcategory: currentSubcategory,
            product: this.category.PricingCalendarProduct,
          },
        })
      }
    } else {
      this.$store.dispatch('products/resetSelectedProductDefaults')
      this.$store.dispatch('products/clearSelectedProduct')
      if (window.storeSettings.CloudEnabled && !this.category.UseLegacy) {
        window.location.href = categoryGetters.getCategoryLink({ category: this.category })
      } else {
        this.$router.push({
          name: 'product-category',
          params: { category: currentCategory, subcategory: currentSubcategory },
        })
      }
    }
  }

  private convertProductModel(productInput: any): ProductInterface {
    return {
      id: productInput.Id,
      imageUrl: productInput.DefaultPictureModel?.ImageUrl,
      name: productInput.Name,
    }
  }

  private toggleCartCard() {
    this.$store.dispatch('cart/toggleCartCard')
    if (this.showCartCard && this.$refs.detailSummaryBarWrapper) {
      ; (this.$refs.detailSummaryBarWrapper as HTMLElement).classList.add('open')
    }
  }

  get showTitleOverCarousel(): boolean {
    const showTitleOverCarouselSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showTitleOverCarousel`
    )
    // return !!(showTitleOverCarouselSetting && showTitleOverCarouselSetting === 'true')
    return false
  }

  get showImageCarousel(): boolean {
    const showImageCarouselSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showImageCarousel`
    )
    // return !!(showImageCarouselSetting && showImageCarouselSetting === 'true')
    return false
  }

  get showImageCarouselArrows(): boolean {
    const showImageCarouselArrowsSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showImageCarouselArrows`
    )
    return !!(showImageCarouselArrowsSetting && showImageCarouselArrowsSetting === 'true')
  }

  get showImageCarouselDelimeters(): boolean {
    const showImageCarouselDelimetersSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showImageCarouselDelimeters`
    )
    return !!(showImageCarouselDelimetersSetting && showImageCarouselDelimetersSetting === 'true')
  }

  get category() {
    return this.$store.getters['products/category']
  }

  get categoryName() {
    return this.category ? this.category.Name : null
  }

  get productPhotos(): any[] {
    var photoset: any[] = []
    if (this.product) {
      photoset = _.filter(this.product.PictureModels, function (o) {
        return o.Title.toUpperCase() !== 'ICON'
      })
    }
    return photoset
  }

  get parkingMapPhoto(): any {
    // The title of the Parking Map image should be "Parking Map"
    // We standardize for capitalization and spaces
    return this.productPhotos
      ? this.productPhotos.find((img) => img.Title.toUpperCase().replace(' ', '') === 'PARKINGMAP')
      : ''
  }

  get lotIdAttribute() {
    return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Arrive Parking Lot Id') : null
  }

  get lotNameAttribute() {
    return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Lot Name') : null
  }

  get lotNameAttributeValue() {
    return this.lotNameAttribute ? this.lotNameAttribute.SelectedValue : ''
  }

  get timeAttribute() {
    return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Parking Time') : null
  }

  get timeAttributeValue() {
    return this.timeAttribute ? this.timeAttribute.SelectedValue : ''
  }

  get dateAttribute() {
    const attr = this.product
      ? this.product.ProductAttributes.find((attr) => attr.Name === 'Arrive Parking Date')
      : null
    attr.IsDate = true
    return attr
  }

  get startDateAttribute() {
    return this.product
      ? this.product.ProductAttributes.find((attr) => attr.IsDate && attr.Name !== 'Arrive Parking Date')
      : null
  }

  get priceAttribute() {
    return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Arrive Parking Price') : null
  }

  get priceAttributeValue() {
    let price =
      this.priceAttribute && this.priceAttribute.SelectedValue
        ? `$${parseFloat(this.priceAttribute.SelectedValue, 0).toFixed(2)}`
        : ''
    if (price && endsWith(price, '.00')) {
      price = price.substring(0, price.length - 3)
    }

    return price
  }

  get eventIdAttribute() {
    return this.product ? this.product.ProductAttributes.find((attr) => attr.Name === 'Arrive Parking Event Id') : null
  }
}
